import { createContext } from 'react';
import { CurrentUserQuery } from '../types/graphqlTypes';

export type UserContextType = NonNullable<Required<CurrentUserQuery>['currentUser']>;
export const UserContext = createContext<UserContextType>({} as UserContextType);
